// Compare Safes JavaScript functionality
let currentModalSlot = null;
let productData = null;
let currentSafe = null; // Store current safe being viewed

// Initialize the comparison system
document.addEventListener('DOMContentLoaded', function() {
  console.log('Compare section JavaScript loaded');
  
  // Load product data from JSON script tag
  const dataScript = document.getElementById('compare-products-data');
  console.log('Data script found:', !!dataScript);
  
  if (dataScript) {
    try {
      productData = JSON.parse(dataScript.textContent);
      console.log('Product data loaded:', productData);
      console.log('Similar products found:', productData.similarProducts?.length || 0);
      
      // Get current safe from data attribute or URL parameter
      currentSafe = getCurrentSafeFromPage();
      console.log('Current safe detected:', currentSafe?.title || 'none');
      
      // Initialize comparison with related safes
      if (currentSafe) {
        initializeRelatedSafes(currentSafe);
      }
    } catch (error) {
      console.error('Error parsing product data:', error);
    }
  } else {
    console.error('compare-products-data script tag not found');
  }

  // Add event listeners
  setupEventListeners();
  
  // Animate feature bars on load
  setTimeout(() => animateFeatureBars(), 500);
  
  // Initialize Lucide icons
  if (typeof lucide !== 'undefined' && lucide.createIcons) {
    lucide.createIcons();
  }
});

// Update the getCurrentSafeFromPage function to verify we're using the correct data
function getCurrentSafeFromPage() {
  // Start by getting the current product from the JSON data
  if (productData && productData.currentProduct) {
    console.log('Current product security text:', productData.currentProduct.security);
    return productData.currentProduct;
  }
  
  // If that doesn't work, try other methods as fallback
  const productSection = document.querySelector('.product-section, [data-product-id]');
  if (productSection) {
    const productId = productSection.dataset.productId;
    if (productId && productData && productData.allProducts) {
      return productData.allProducts.find(p => p.id.toString() === productId.toString());
    }
  }
  
  // Alternative: Try to get from URL parameter
  const urlParams = new URLSearchParams(window.location.search);
  const productId = urlParams.get('product_id');
  if (productId && productData && productData.allProducts) {
    return productData.allProducts.find(p => p.id.toString() === productId.toString());
  }
  
  // Default to first product if we can't determine current product
  return productData && productData.allProducts && productData.allProducts[0];
}

function extractSecurityLevel(product) {
  if (!product) {
    console.log('No product provided to extractSecurityLevel');
    return 0;
  }
  
  // Try the product_card_feature_1 metafield first (this is the security field)
  if (product.security && product.security !== 'N/A' && product.security !== '') {
    
    // Look for "Level X out of Y" or "Level X" pattern
    let match = product.security.match(/Level\s+(\d+)(?:\s+out\s+of\s+\d+)?/i);
    
    if (match && match[1]) {
      const level = parseInt(match[1]);
      return Math.min(level, 10); // Cap at 10
    }
    
    // Try alternative patterns like "Security Level X" or just "X"
    match = product.security.match(/(?:Security\s+)?Level\s*:?\s*(\d+)/i);
    if (match && match[1]) {
      const level = parseInt(match[1]);
      console.log(`Found alternative security level ${level} for product ${product.title}`);
      return Math.min(level, 10);
    }
    
    // Try to extract just a number if it's a simple format
    match = product.security.match(/(\d+)/);
    if (match && match[1]) {
      const level = parseInt(match[1]);
      // Only use if it's a reasonable security level (1-10)
      if (level >= 1 && level <= 10) {
        console.log(`Found numeric security level ${level} for product ${product.title}`);
        return level;
      }
    }
  }
  
  // Fallback: try the direct securityLevel field
  if (product.securityLevel && product.securityLevel !== 'N/A') {
    const level = parseInt(product.securityLevel);
    if (!isNaN(level)) {
      console.log(`Found direct security level ${level} for product ${product.title}`);
      return Math.min(level, 10); // Cap at 10
    }
  }
  
  console.log('No security level found for:', product.title, 'Security field value:', product.security);
  return 0;
}

function extractFireTime(product) {
  if (!product) {
    console.log('No product provided to extractFireTime');
    return 0;
  }
  
  // Try the product_card_feature_2 metafield (fire protection)
  if (product.fire && product.fire !== '') {
    console.log('Extracting fire time from product_card_feature_2:', product.fire);
    
    // Try multiple patterns to extract fire time
    let fireTime = 0;
    
    // Method 1: Look for "X Minute" or "X Minutes" pattern (case insensitive)
    let match = product.fire.match(/(\d+)\s*Minutes?/i);
    if (match && match[1]) {
      fireTime = parseInt(match[1]);
    }
    
    // Method 2: If no "Minute" found, try splitting like the Liquid template does
    if (!fireTime) {
      const fireParts = product.fire.split(' Minute');
      if (fireParts.length > 0) {
        // Get the last word before " Minute"
        const beforeMinute = fireParts[0].trim();
        const words = beforeMinute.split(' ');
        const lastWord = words[words.length - 1];
        const timeValue = parseInt(lastWord);
        if (!isNaN(timeValue)) {
          fireTime = timeValue;
        }
      }
    }
    
    // Method 3: Try to extract any number from the string as fallback
    if (!fireTime) {
      const numbers = product.fire.match(/\d+/g);
      if (numbers && numbers.length > 0) {
        // Take the first number found
        fireTime = parseInt(numbers[0]);
      }
    }
    
    if (fireTime > 0) {
      console.log(`Found fire time ${fireTime} minutes for product ${product.title}`);
      return fireTime;
    }
  }
  
  // Fallback: try the fireRatingTime field
  if (product.fireRatingTime && product.fireRatingTime !== '') {
    const time = parseInt(product.fireRatingTime);
    if (!isNaN(time)) {
      console.log(`Found fire rating time ${time} for product ${product.title}`);
      return time;
    }
  }
  
  console.log('No fire time found for:', product.title);
  return 0;
}

function getSecurityScore(product) {
  const securityLevel = extractSecurityLevel(product);
  return securityLevel; // Return raw level (1-10)
}

function getFireScore(product) {
  const fireTime = extractFireTime(product);
  if (fireTime > 0) {
    // Convert time (0-150) to 1-10 scale
    const score = Math.ceil((fireTime / 150) * 10);
    return Math.min(score, 10);
  }
  return 1; // Minimum score
}

function getCapacityScore(product) {
  const gunCount = parseInt(product.gunCount) || 0;
  if (gunCount > 0) {
    // Convert gun count (0-73) to 1-10 scale  
    const score = Math.ceil((gunCount / 73) * 10);
    return Math.min(score, 10);
  }
  return 1; // Minimum score
}

function getMetricGrade(score, maxScore) {
  // If score is 0, return None
  if (score === 0) {
    return { grade: 'None', class: 'progress-none' };
  }
  
  const percentage = (score / maxScore) * 100;
  
  if (percentage >= 70) {
    return { grade: 'Best', class: 'progress-best' };
  } else if (percentage >= 40) {
    return { grade: 'Better', class: 'progress-better' };
  } else {
    return { grade: 'Good', class: 'progress-good' };
  } 
}

function generateIconRating(score, maxScore, iconType) {
  let iconsHTML = '';
  
  // Generate filled icons
  for (let i = 1; i <= maxScore; i++) {
    const isFilled = i <= score;
    const iconClass = `rating-icon ${iconType} ${isFilled ? 'filled' : 'empty'}`;
    
    if (iconType === 'security') {
      iconsHTML += `<svg class="${iconClass}" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="${isFilled ? 'currentColor' : 'none'}" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"/>
      </svg>`;
    } else if (iconType === 'fire') {
      iconsHTML += `<svg class="${iconClass}" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="${isFilled ? 'currentColor' : 'none'}" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <path d="M8.5 14.5A2.5 2.5 0 0 0 11 12c0-1.38-.5-2-1-3-1.072-2.143-.224-4.054 2-6 .5 2.5 2 4.9 4 6.5 2 1.6 3 3.5 3 5.5a7 7 0 1 1-14 0c0-1.153.433-2.294 1-3a2.5 2.5 0 0 0 2.5 2.5z"/>
      </svg>`;
    } else if (iconType === 'capacity') {
      iconsHTML += `<svg class="${iconClass}" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="${isFilled ? 'currentColor' : 'none'}" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <circle cx="12" cy="12" r="10"/>
      </svg>`;
    }
  }
  
  return iconsHTML;
}

function initializeRelatedSafes(currentProduct) {
  if (!productData || !productData.allProducts || !currentProduct) {
    console.error('Cannot initialize related safes - missing data');
    return;
  }
  
  // Extract current product's security level and gun capacity status
  const currentSecurityLevel = extractSecurityLevel(currentProduct);
  const currentHasGunCapacity = hasGunCapacity(currentProduct);
  
  console.log('Current product security level:', currentSecurityLevel);
  console.log('Current product has gun capacity:', currentHasGunCapacity);
  
  // Log all products with their security levels and gun capacity for debugging
  console.log('All available products with security levels and gun capacity:');
  productData.allProducts.forEach(p => {
    const level = extractSecurityLevel(p);
    const hasGuns = hasGunCapacity(p);
    const gunCount = parseInt(p.gunCount) || 0;
  });
  
  // Find product with one lower security level that matches gun capacity feature
  const lowerProduct = findProductWithSecurityLevelAndGunCapacity(currentSecurityLevel - 1, currentHasGunCapacity);
  
  // Find product with one higher security level that matches gun capacity feature
  const higherProduct = findProductWithSecurityLevelAndGunCapacity(currentSecurityLevel + 1, currentHasGunCapacity);
  
  // Load products into comparison slots
  if (lowerProduct) {
    console.log(`Loading lower security product (Level ${extractSecurityLevel(lowerProduct)}, Gun Capacity: ${hasGunCapacity(lowerProduct)}): ${lowerProduct.title}`);
    loadProductIntoSlot('left', lowerProduct);
  } else {
    console.log(`No product with security level ${currentSecurityLevel - 1} and matching gun capacity found`);
    // Try to find any product with a lower level that matches gun capacity
    for (let level = currentSecurityLevel - 2; level >= 1; level--) {
      const fallbackProduct = findProductWithSecurityLevelAndGunCapacity(level, currentHasGunCapacity);
      if (fallbackProduct) {
        console.log(`Using fallback lower product (Level ${level}, Gun Capacity: ${hasGunCapacity(fallbackProduct)}): ${fallbackProduct.title}`);
        loadProductIntoSlot('left', fallbackProduct);
        break;
      }
    }
    
    // If still no match, try without gun capacity constraint
    if (!lowerProduct) {
      const anyLowerProduct = findProductWithSecurityLevelOnly(currentSecurityLevel - 1);
      if (anyLowerProduct) {
        console.log(`Using any lower security product (Level ${extractSecurityLevel(anyLowerProduct)}): ${anyLowerProduct.title}`);
        loadProductIntoSlot('left', anyLowerProduct);
      }
    }
  }
  
  if (higherProduct) {
    console.log(`Loading higher security product (Level ${extractSecurityLevel(higherProduct)}, Gun Capacity: ${hasGunCapacity(higherProduct)}): ${higherProduct.title}`);
    loadProductIntoSlot('right', higherProduct);
  } else {
    console.log(`No product with security level ${currentSecurityLevel + 1} and matching gun capacity found`);
    // Try to find any product with a higher level that matches gun capacity
    for (let level = currentSecurityLevel + 2; level <= 10; level++) {
      const fallbackProduct = findProductWithSecurityLevelAndGunCapacity(level, currentHasGunCapacity);
      if (fallbackProduct) {
        console.log(`Using fallback higher product (Level ${level}, Gun Capacity: ${hasGunCapacity(fallbackProduct)}): ${fallbackProduct.title}`);
        loadProductIntoSlot('right', fallbackProduct);
        break;
      }
    }
    
    // If still no match, try without gun capacity constraint
    if (!higherProduct) {
      const anyHigherProduct = findProductWithSecurityLevelOnly(currentSecurityLevel + 1);
      if (anyHigherProduct) {
        console.log(`Using any higher security product (Level ${extractSecurityLevel(anyHigherProduct)}): ${anyHigherProduct.title}`);
        loadProductIntoSlot('right', anyHigherProduct);
      }
    }
  }
}

// Helper function to check if a product has gun capacity feature
function hasGunCapacity(product) {
  if (!product) return false;
  
  // Check if gun count exists and is greater than 0
  const gunCount = parseInt(product.gunCount) || 0;
  return gunCount > 0;
}

// Enhanced helper function to find a product with specified security level and gun capacity match
function findProductWithSecurityLevelAndGunCapacity(targetLevel, shouldHaveGunCapacity) {
  if (!productData || !productData.allProducts) return null;
  
  // Filter products that match both the target security level and gun capacity criteria
  const matchingProducts = productData.allProducts.filter(p => {
    const level = extractSecurityLevel(p);
    const hasGuns = hasGunCapacity(p);
    return level === targetLevel && hasGuns === shouldHaveGunCapacity;
  });
  
  if (matchingProducts.length === 0) {
    console.log(`No product found with security level ${targetLevel} and gun capacity: ${shouldHaveGunCapacity}`);
    return null;
  }
  
  // If multiple products match, pick the first one
  // Could be enhanced to pick based on other criteria like price similarity
  return matchingProducts[0];
}

// Fallback helper function to find a product with specified security level only (no gun capacity constraint)
function findProductWithSecurityLevelOnly(targetLevel) {
  if (!productData || !productData.allProducts) return null;
  
  // Filter products that match the target security level only
  const matchingProducts = productData.allProducts.filter(p => {
    const level = extractSecurityLevel(p);
    return level === targetLevel;
  });
  
  if (matchingProducts.length === 0) {
    console.log(`No product found with security level ${targetLevel}`);
    return null;
  }
  
  // If multiple products with the same security level, pick the first one
  return matchingProducts[0];
}

function setupEventListeners() {
  // Add product buttons - Use event delegation for reliability
  document.addEventListener('click', function(event) {
    const addBtn = event.target.closest('[data-compare-slot]');
    if (addBtn) {
      const slot = addBtn.getAttribute('data-compare-slot');
      openProductModal(slot);
      return;
    }
    
    // Close modal when clicking outside
    const modal = document.getElementById('productModal');
    if (event.target === modal) {
      closeProductModal();
      return;
    }
    
    // Close modal button
    if (event.target.id === 'closeModalBtn' || event.target.closest('#closeModalBtn')) {
      closeProductModal();
      return;
    }
  });

  // Search functionality
  const searchInput = document.getElementById('productSearch');
  if (searchInput) {
    searchInput.addEventListener('input', debounce(filterProducts, 300));
  }

  // Keyboard navigation
  document.addEventListener('keydown', function(event) {
    const modal = document.getElementById('productModal');
    if (modal && modal.style.display === 'block' && event.key === 'Escape') {
      closeProductModal();
    }
  });
  
  // Reset comparison button if available
  const resetComparisonBtn = document.getElementById('resetComparison');
  if (resetComparisonBtn) {
    resetComparisonBtn.addEventListener('click', function() {
      if (currentSafe) {
        initializeRelatedSafes(currentSafe);
      }
    });
  }
}
// ...existing code...

// Open product selection modal
function openProductModal(slot) {
  console.log('openProductModal called with slot:', slot);
  console.log('productData available:', !!productData);
  
  // If productData is not loaded yet, try to load it
  if (!productData) {
    console.log('Product data not loaded, attempting to load...');
    const dataScript = document.getElementById('compare-products-data');
    if (dataScript) {
      try {
        productData = JSON.parse(dataScript.textContent);
        console.log('Product data loaded on demand:', productData);
      } catch (error) {
        console.error('Error parsing product data on demand:', error);
        alert('Unable to load product data. Please refresh the page and try again.');
        return;
      }
    } else {
      console.error('compare-products-data script tag not found');
      alert('Product data not available. Please refresh the page and try again.');
      return;
    }
  }
  
  currentModalSlot = slot;
  const modal = document.getElementById('productModal');
  const productGrid = document.getElementById('productGrid');
  
  console.log('Modal element found:', !!modal);
  console.log('Product grid found:', !!productGrid);
  
  if (!productData || !productData.allProducts) {
    console.error('Product data not available', productData);
    alert('No products available for comparison. Please refresh the page and try again.');
    return;
  }

  console.log('Number of products available:', productData.allProducts.length);

  // Clear previous products and show skeleton loading
  productGrid.innerHTML = '';
  
  // Determine number of skeleton cards (max 12, min 6)
  const expectedProductCount = productData.allProducts.length;
  const skeletonCount = Math.min(Math.max(expectedProductCount, 6), 12);
  
  // Show skeleton cards first for smooth loading experience
  for (let i = 0; i < skeletonCount; i++) {
    const skeletonCard = createSkeletonCard();
    // Add slight delay to each card for staggered appearance
    skeletonCard.style.animationDelay = `${i * 50}ms`;
    productGrid.appendChild(skeletonCard);
  }
  
  // Show modal with skeleton cards
  modal.style.display = 'block';
  document.body.style.overflow = 'hidden';
  
  // Focus on search input
  const searchInput = document.getElementById('productSearch');
  if (searchInput) {
    searchInput.focus();
    searchInput.value = '';
  }
  
  // Load actual products after a short delay for smooth UX
  setTimeout(() => {
    // Clear skeleton cards
    productGrid.innerHTML = '';
    
    // Populate real products with staggered animation
    productData.allProducts.forEach((product, index) => {
      const productCard = createModalProductCard(product);
      productCard.style.opacity = '0';
      productCard.style.transform = 'translateY(10px)';
      productCard.style.transition = 'opacity 0.3s ease, transform 0.3s ease';
      productGrid.appendChild(productCard);
      
      // Staggered fade-in animation
      setTimeout(() => {
        productCard.style.opacity = '1';
        productCard.style.transform = 'translateY(0)';
      }, index * 30);
    });
  }, 300); // 300ms delay for skeleton effect
}

// Close product selection modal
function closeProductModal() {
  const modal = document.getElementById('productModal');
  modal.style.display = 'none';
  document.body.style.overflow = 'auto';
  currentModalSlot = null;
}

// Create skeleton loading card
function createSkeletonCard() {
  const card = document.createElement('div');
  card.className = 'modal-product-card skeleton-card';
  
  // Add some randomness to make it look more natural
  const titleWidth = 60 + Math.random() * 30; // 60-90%
  const textWidth = 40 + Math.random() * 30;  // 40-70%
  const priceWidth = 30 + Math.random() * 25; // 30-55%
  
  card.innerHTML = `
    <div class="skeleton skeleton-image"></div>
    <div class="skeleton skeleton-title" style="width: ${titleWidth}%"></div>
    <div class="skeleton skeleton-text" style="width: ${textWidth}%"></div>
    <div class="skeleton skeleton-price" style="width: ${priceWidth}%"></div>
  `;
  
  return card;
}

// Create modal product card
function createModalProductCard(product) {
  const card = document.createElement('div');
  card.className = 'modal-product-card';
  card.setAttribute('tabindex', '0');
  card.setAttribute('role', 'button');
  card.setAttribute('aria-label', `Select ${product.title} for comparison`);
  
  // Extract security level for display
  const securityText = product.security || product.securityLevel || 'Security Rating';
  
  card.innerHTML = `
    <img src="${product.image}" alt="${product.title}" loading="lazy">
    <h4>${product.titlePart}</h4>
    <p>${securityText}</p>
    <div class="price">${formatPrice(product.price)}</div>
  `;
  
  // Add click handler
  card.addEventListener('click', function() {
    selectProduct(product);
  });
  
  // Add keyboard handler
  card.addEventListener('keydown', function(event) {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      selectProduct(product);
    }
  });
  
  return card;
}

// Select product for comparison
function selectProduct(product) {
  if (!currentModalSlot) return;
  
  loadProductIntoSlot(currentModalSlot, product);
  closeProductModal();
}

// Load product into comparison slot
function loadProductIntoSlot(slot, product) {
  console.log('loadProductIntoSlot called with slot:', slot, 'product:', product?.title || 'undefined');
  
  const container = document.getElementById(`productDisplay${slot.charAt(0).toUpperCase() + slot.slice(1)}`);
  const addContainer = document.getElementById(`addProduct${slot.charAt(0).toUpperCase() + slot.slice(1)}`);
  
  if (!container || !addContainer) {
    console.error('Container not found for slot:', slot);
    console.error('Container:', !!container, 'AddContainer:', !!addContainer);
    return;
  }
  
  if (!product) {
    console.error('No product provided to loadProductIntoSlot');
    return;
  }
  
  // Hide add button, show product
  addContainer.style.display = 'none';
  container.style.display = 'block';
  
  // Generate product HTML
  container.innerHTML = generateProductHTML(product, slot);
  
  // Initialize Lucide icons for the new content
  if (typeof lucide !== 'undefined' && lucide.createIcons) {
    lucide.createIcons();
  }
  
  // Animate feature bars
  setTimeout(() => animateFeatureBars(), 200);
}

// Generate product comparison HTML
function generateProductHTML(product, slot) {
  const isOnSale = product.compareAtPrice && product.compareAtPrice > product.price;
  const rating = generateRandomRating();
  
  const securityScore = getSecurityScore(product);
  const fireScore = getFireScore(product);
  const capacityScore = getCapacityScore(product);
  
  // Get metric grades
  const securityGrade = getMetricGrade(securityScore, 10);
  const fireGrade = getMetricGrade(fireScore, 10);
  const capacityGrade = getMetricGrade(capacityScore, 10);
  
  return `
    <div class="clickable-card safe-comparison-card" onclick="window.location.href='${product.url}'">
      <div class="product-badges">
        ${isOnSale ? '<div class="ranking-badge">ON SALE</div>' : ''}
        ${product.madeInUSA ? '<div class="feature-badge usa-made">MADE IN USA</div>' : ''}
      </div>

      <button class="remove-product-btn" onclick="event.stopPropagation(); removeProductFromSlot('${slot}')" aria-label="Remove product from comparison">
        ×
      </button>

      <div class="product-image">
        <img src="${product.image}" alt="${product.title}" loading="lazy">
      </div>

      <div class="product-info">
        <h3 class="product-name">${product.titlePart}</h3>
        <p class="product-description">${product.security || 'Advanced security features for maximum protection.'}</p>
        
        <div class="product-price">
          ${isOnSale ? `<span class="original-price">${formatPrice(product.compareAtPrice)}</span>` : ''}
          <span class="current-price">${formatPrice(product.price)}</span>
        </div>
      </div>

      <div class="metrics-section">
        <div class="metric-item">
          <div class="metric-header">
            <i data-lucide="shield"></i>
            <span class="metric-label">Security</span>
          </div>
          <div class="progress-bar-container">
            <div class="progress-bar ${securityGrade.class}" data-score="${securityScore}" data-max="10">
              <div class="progress-fill"></div>
            </div>
            <span class="progress-grade">${securityGrade.grade}</span>
          </div>
        </div>

        <div class="metric-item">
          <div class="metric-header">
            <i data-lucide="flame"></i>
            <span class="metric-label">Fire Protection</span>
          </div>
          <div class="progress-bar-container">
            <div class="progress-bar ${fireGrade.class}" data-score="${fireScore}" data-max="10">
              <div class="progress-fill"></div>
            </div>
            <span class="progress-grade">${fireGrade.grade}</span>
          </div>
        </div>

        <div class="metric-item">
          <div class="metric-header">
            <i data-lucide="package"></i>
            <span class="metric-label">Capacity</span>
          </div>
          <div class="progress-bar-container">
            <div class="progress-bar ${capacityGrade.class}" data-score="${capacityScore}" data-max="10">
              <div class="progress-fill"></div>
            </div>
            <span class="progress-grade">${capacityGrade.grade}</span>
          </div>
        </div>
      </div>

      <div class="features-section">
        <h4>Key Features</h4>
        <ul class="features-list">
          ${product.gunCount && product.gunCount > 0 ? `<li><span>Gun Capacity: ${product.gunCount} guns</span></li>` : ''}
          ${product.steelGauge ? `<li><span>Steel Gauge: ${product.steelGauge}</span></li>` : ''}
          ${extractFireTime(product) ? `<li><span>Fire Rating: ${extractFireTime(product)} min</span></li>` : ''}
          ${product.burglaryRating ? `<li><span>Burglary Rating: ${product.burglaryRating}</span></li>` : ''}
        </ul>
      </div>

      <div class="product-actions">
        <button class="cta-button" onclick="event.stopPropagation(); window.location.href='${product.url}'">
          Choose This Safe
        </button>
      </div>
    </div>
  `;
}

// Remove product from comparison slot
function removeProductFromSlot(slot) {
  const container = document.getElementById(`productDisplay${slot.charAt(0).toUpperCase() + slot.slice(1)}`);
  const addContainer = document.getElementById(`addProduct${slot.charAt(0).toUpperCase() + slot.slice(1)}`);
  
  if (container && addContainer) {
    container.style.display = 'none';
    addContainer.style.display = 'flex';
    container.innerHTML = '';
  }
}

// Filter products based on search
function filterProducts() {
  const searchTerm = document.getElementById('productSearch').value.toLowerCase();
  const productCards = document.querySelectorAll('.modal-product-card');
  
  productCards.forEach(card => {
    const title = card.querySelector('h4').textContent.toLowerCase();
    const description = card.querySelector('p').textContent.toLowerCase();
    
    if (title.includes(searchTerm) || description.includes(searchTerm)) {
      card.style.display = 'block';
    } else {
      card.style.display = 'none';
    }
  });
}

// Utility functions
function formatPrice(price) {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).format(price / 100);
}

function generateRandomRating() {
  const scores = [4.2, 4.3, 4.4, 4.5, 4.6, 4.7, 4.8];
  const counts = [89, 124, 156, 203, 278, 341, 425];
  const index = Math.floor(Math.random() * scores.length);
  
  return {
    score: scores[index],
    count: counts[index]
  };
}

function getSecurityGrade(product) {
  const score = getSecurityScore(product);
  if (score >= 8) return 'BEST';
  if (score >= 6) return 'BETTER';
  if (score >= 4) return 'GOOD';
  return 'FAIR';
}

function getFireGrade(product) {
  const score = getFireScore(product);
  if (score >= 8) return 'BEST';
  if (score >= 6) return 'BETTER';
  if (score >= 4) return 'GOOD';
  return 'FAIR';
}

function getCapacityGrade(product) {
  const score = getCapacityScore(product);
  if (score >= 8) return 'BEST';
  if (score >= 6) return 'BETTER';
  if (score >= 4) return 'GOOD';
  return 'FAIR';
}

// Animate feature bars - Fixed version
function animateFeatureBars() {
  const progressBars = document.querySelectorAll('.progress-bar');
  progressBars.forEach((bar, index) => {
    const score = parseInt(bar.dataset.score) || 0;
    const maxScore = parseInt(bar.dataset.max) || 10;
    const percentage = (score / maxScore) * 100;
    const fill = bar.querySelector('.progress-fill');
    
    if (fill) {
      // Add animation delay based on index
      setTimeout(() => {
        fill.style.width = `${percentage}%`;
      }, index * 150);
    }
  });
}

// Debounce utility
function debounce(func, wait) {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}

// Intersection Observer for animations
const observerOptions = {
  threshold: 0.1,
  rootMargin: '0px 0px -50px 0px'
};

const observer = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      entry.target.classList.add('animate-in');
      // Trigger animation for bars in this card
      setTimeout(() => animateFeatureBars(), 200);
    }
  });
}, observerOptions);

// Observe comparison cards
document.addEventListener('DOMContentLoaded', function() {
  const cards = document.querySelectorAll('.safe-comparison-card');
  cards.forEach(card => observer.observe(card));
});

// Export functions for global access - Override the null declarations
window.openProductModal = openProductModal;
window.closeProductModal = closeProductModal;
window.loadProductIntoSlot = loadProductIntoSlot;
window.removeProductFromSlot = removeProductFromSlot;
window.initializeRelatedSafes = initializeRelatedSafes;
window.getCurrentSafeFromPage = getCurrentSafeFromPage;

// Add a manual initialization function for debugging
window.initializeCompareSection = function() {
  console.log('Manual initialization called');
  const dataScript = document.getElementById('compare-products-data');
  if (dataScript) {
    try {
      productData = JSON.parse(dataScript.textContent);
      console.log('Product data manually loaded:', productData);
      
      currentSafe = getCurrentSafeFromPage();
      console.log('Current safe detected:', currentSafe?.title || 'none');
      
      if (currentSafe) {
        initializeRelatedSafes(currentSafe);
      }
    } catch (error) {
      console.error('Error in manual initialization:', error);
    }
  } else {
    console.error('compare-products-data script tag not found in manual init');
  }
};